import Header from './header'
import Footer from './footer'

export const metadata: any = {
  title: 'Charme - Beauty Services',
  description: 'Professional makeup and beauty services',
}

export default function RootLayout({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
    </>
  )
}
